// DJ&A Store Locator data. Generated from the Shopify-ready CSV.
// To update: replace this file with a regenerated list from the latest CSV.
window.DJA_STORE_LOCATIONS = [
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6403",
    "displayLocation": "Brandon, FL",
    "city": "Brandon",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Brandon%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8284",
    "displayLocation": "Tyler, TX",
    "city": "Tyler",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Tyler%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6235",
    "displayLocation": "San Diegoeast, CA",
    "city": "San Diegoeast",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20San%20Diegoeast%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6464",
    "displayLocation": "Des Plaines, IL",
    "city": "Des Plaines",
    "state": "IL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Des%20Plaines%2C%20IL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6614",
    "displayLocation": "El Monte, CA",
    "city": "El Monte",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20El%20Monte%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6615",
    "displayLocation": "Fountain Valley, CA",
    "city": "Fountain Valley",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Fountain%20Valley%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4915",
    "displayLocation": "Bullhead City, AZ",
    "city": "Bullhead City",
    "state": "AZ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Bullhead%20City%2C%20AZ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4785",
    "displayLocation": "Sanford, FL",
    "city": "Sanford",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Sanford%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4969",
    "displayLocation": "Bentonville, AR",
    "city": "Bentonville",
    "state": "AR",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Bentonville%2C%20AR"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6565",
    "displayLocation": "Rapid City, SD",
    "city": "Rapid City",
    "state": "SD",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Rapid%20City%2C%20SD"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8151",
    "displayLocation": "Panama City, FL",
    "city": "Panama City",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Panama%20City%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4950",
    "displayLocation": "Hendersonville, NC",
    "city": "Hendersonville",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Hendersonville%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8155",
    "displayLocation": "Gainesville, FL",
    "city": "Gainesville",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Gainesville%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8236",
    "displayLocation": "Gulfport, MS",
    "city": "Gulfport",
    "state": "MS",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Gulfport%2C%20MS"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4861",
    "displayLocation": "St Petersburg, FL",
    "city": "St Petersburg",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20St%20Petersburg%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4799",
    "displayLocation": "Citrus Heights, CA",
    "city": "Citrus Heights",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Citrus%20Heights%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6671",
    "displayLocation": "Freehold, NJ",
    "city": "Freehold",
    "state": "NJ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Freehold%2C%20NJ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6628",
    "displayLocation": "Torrance, CA",
    "city": "Torrance",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Torrance%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4801",
    "displayLocation": "Riverview, FL",
    "city": "Riverview",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Riverview%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6188",
    "displayLocation": "Austin Lakeline, TX",
    "city": "Austin Lakeline",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Austin%20Lakeline%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6573",
    "displayLocation": "Jacksonville, NC",
    "city": "Jacksonville",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Jacksonville%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4857",
    "displayLocation": "Cape Coral (Pine), FL",
    "city": "Cape Coral (Pine)",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Cape%20Coral%20%28Pine%29%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4991",
    "displayLocation": "Cocoa, FL",
    "city": "Cocoa",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Cocoa%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4703",
    "displayLocation": "Albuquerque, NM",
    "city": "Albuquerque",
    "state": "NM",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Albuquerque%2C%20NM"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4852",
    "displayLocation": "Wesley Chapel, FL",
    "city": "Wesley Chapel",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Wesley%20Chapel%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6255",
    "displayLocation": "Planonorth, TX",
    "city": "Planonorth",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Planonorth%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6369",
    "displayLocation": "Edison, NJ",
    "city": "Edison",
    "state": "NJ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Edison%2C%20NJ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8181",
    "displayLocation": "Alexandria, LA",
    "city": "Alexandria",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Alexandria%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6363",
    "displayLocation": "Jacksonville West, FL",
    "city": "Jacksonville West",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Jacksonville%20West%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6582",
    "displayLocation": "Bluffton, SC",
    "city": "Bluffton",
    "state": "SC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Bluffton%2C%20SC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8138",
    "displayLocation": "Daytona Beach, FL",
    "city": "Daytona Beach",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Daytona%20Beach%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6361",
    "displayLocation": "Ft. Walton Beach, FL",
    "city": "Ft. Walton Beach",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Ft.%20Walton%20Beach%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6373",
    "displayLocation": "Vienna, WV",
    "city": "Vienna",
    "state": "WV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Vienna%2C%20WV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8119",
    "displayLocation": "Pensacola, FL",
    "city": "Pensacola",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Pensacola%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6386",
    "displayLocation": "Concord, NH",
    "city": "Concord",
    "state": "NH",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Concord%2C%20NH"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4784",
    "displayLocation": "Las Cruces, NM",
    "city": "Las Cruces",
    "state": "NM",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Las%20Cruces%2C%20NM"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6622",
    "displayLocation": "Sacramento, CA",
    "city": "Sacramento",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Sacramento%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4783",
    "displayLocation": "Garland, TX",
    "city": "Garland",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Garland%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4822",
    "displayLocation": "Murrieta, CA",
    "city": "Murrieta",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Murrieta%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4983",
    "displayLocation": "Las Vegas (Rainbow), NV",
    "city": "Las Vegas (Rainbow)",
    "state": "NV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Las%20Vegas%20%28Rainbow%29%2C%20NV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6521",
    "displayLocation": "Houma, LA",
    "city": "Houma",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Houma%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6405",
    "displayLocation": "Yuba City, CA",
    "city": "Yuba City",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Yuba%20City%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6612",
    "displayLocation": "Concord, CA",
    "city": "Concord",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Concord%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "7658",
    "displayLocation": "Brunswick, GA",
    "city": "Brunswick",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Brunswick%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8209",
    "displayLocation": "Fayetteville, AR",
    "city": "Fayetteville",
    "state": "AR",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Fayetteville%2C%20AR"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4825",
    "displayLocation": "Hot Springs, AR",
    "city": "Hot Springs",
    "state": "AR",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Hot%20Springs%2C%20AR"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6245",
    "displayLocation": "Harker Heights, TX",
    "city": "Harker Heights",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Harker%20Heights%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8189",
    "displayLocation": "Clarksburg, WV",
    "city": "Clarksburg",
    "state": "WV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Clarksburg%2C%20WV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4794",
    "displayLocation": "Lakelandsouth, FL",
    "city": "Lakelandsouth",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Lakelandsouth%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4985",
    "displayLocation": "Springfield South, MO",
    "city": "Springfield South",
    "state": "MO",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Springfield%20South%2C%20MO"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6348",
    "displayLocation": "Pineville, NC",
    "city": "Pineville",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Pineville%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4761",
    "displayLocation": "Norman, OK",
    "city": "Norman",
    "state": "OK",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Norman%2C%20OK"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6456",
    "displayLocation": "Plattsburgh, NY",
    "city": "Plattsburgh",
    "state": "NY",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Plattsburgh%2C%20NY"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6503",
    "displayLocation": "Hattiesburg, MS",
    "city": "Hattiesburg",
    "state": "MS",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Hattiesburg%2C%20MS"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8273",
    "displayLocation": "Shreveport, LA",
    "city": "Shreveport",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Shreveport%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4828",
    "displayLocation": "Orlando Lake Nona, FL",
    "city": "Orlando Lake Nona",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Orlando%20Lake%20Nona%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6616",
    "displayLocation": "Fullerton, CA",
    "city": "Fullerton",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Fullerton%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8141",
    "displayLocation": "Melbourne, FL",
    "city": "Melbourne",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Melbourne%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6327",
    "displayLocation": "Warren, OH",
    "city": "Warren",
    "state": "OH",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Warren%2C%20OH"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4709",
    "displayLocation": "Corona, CA",
    "city": "Corona",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Corona%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6205",
    "displayLocation": "Yuma, AZ",
    "city": "Yuma",
    "state": "AZ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Yuma%2C%20AZ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4837",
    "displayLocation": "Denham Springs, LA",
    "city": "Denham Springs",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Denham%20Springs%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4972",
    "displayLocation": "Port St. Lucie West, FL",
    "city": "Port St. Lucie West",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Port%20St.%20Lucie%20West%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6485",
    "displayLocation": "Tinley Park, IL",
    "city": "Tinley Park",
    "state": "IL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Tinley%20Park%2C%20IL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4989",
    "displayLocation": "Auburn, AL",
    "city": "Auburn",
    "state": "AL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Auburn%2C%20AL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4818",
    "displayLocation": "Brooksville, FL",
    "city": "Brooksville",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Brooksville%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6212",
    "displayLocation": "Orlando, FL",
    "city": "Orlando",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Orlando%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6449",
    "displayLocation": "Paducah, KY",
    "city": "Paducah",
    "state": "KY",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Paducah%2C%20KY"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6659",
    "displayLocation": "Madison Heights, MI",
    "city": "Madison Heights",
    "state": "MI",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Madison%20Heights%2C%20MI"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6686",
    "displayLocation": "Salt Lake City, UT",
    "city": "Salt Lake City",
    "state": "UT",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Salt%20Lake%20City%2C%20UT"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8280",
    "displayLocation": "El Paso, TX",
    "city": "El Paso",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20El%20Paso%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6419",
    "displayLocation": "Traverse City, MI",
    "city": "Traverse City",
    "state": "MI",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Traverse%20City%2C%20MI"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6445",
    "displayLocation": "Port Charlotte, FL",
    "city": "Port Charlotte",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Port%20Charlotte%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8252",
    "displayLocation": "North Charleston, SC",
    "city": "North Charleston",
    "state": "SC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20North%20Charleston%2C%20SC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8254",
    "displayLocation": "Wichita, KS",
    "city": "Wichita",
    "state": "KS",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Wichita%2C%20KS"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6240",
    "displayLocation": "Glendora, CA",
    "city": "Glendora",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Glendora%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6356",
    "displayLocation": "Fishkill, NY",
    "city": "Fishkill",
    "state": "NY",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Fishkill%2C%20NY"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6387",
    "displayLocation": "Pinellas Park, FL",
    "city": "Pinellas Park",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Pinellas%20Park%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6414",
    "displayLocation": "Gastonia, NC",
    "city": "Gastonia",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Gastonia%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8134",
    "displayLocation": "Ft. Smith, AR",
    "city": "Ft. Smith",
    "state": "AR",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Ft.%20Smith%2C%20AR"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8263",
    "displayLocation": "Tulsa, OK",
    "city": "Tulsa",
    "state": "OK",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Tulsa%2C%20OK"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8266",
    "displayLocation": "Sherwood, AR",
    "city": "Sherwood",
    "state": "AR",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Sherwood%2C%20AR"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4802",
    "displayLocation": "Hiram, GA",
    "city": "Hiram",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Hiram%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4998",
    "displayLocation": "The Villages, FL",
    "city": "The Villages",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20The%20Villages%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6448",
    "displayLocation": "New Port Richey, FL",
    "city": "New Port Richey",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20New%20Port%20Richey%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6653",
    "displayLocation": "Gaithersburg, MD",
    "city": "Gaithersburg",
    "state": "MD",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Gaithersburg%2C%20MD"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8299",
    "displayLocation": "Plano, TX",
    "city": "Plano",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Plano%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4936",
    "displayLocation": "Granville, WV",
    "city": "Granville",
    "state": "WV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Granville%2C%20WV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4992",
    "displayLocation": "Elizabethtown, KY",
    "city": "Elizabethtown",
    "state": "KY",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Elizabethtown%2C%20KY"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4820",
    "displayLocation": "Pooler, GA",
    "city": "Pooler",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Pooler%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4942",
    "displayLocation": "Elgin, IL",
    "city": "Elgin",
    "state": "IL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Elgin%2C%20IL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6308",
    "displayLocation": "Columbuswest, OH",
    "city": "Columbuswest",
    "state": "OH",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Columbuswest%2C%20OH"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8128",
    "displayLocation": "Peoria, IL",
    "city": "Peoria",
    "state": "IL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Peoria%2C%20IL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8279",
    "displayLocation": "Amarillo, TX",
    "city": "Amarillo",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Amarillo%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6351",
    "displayLocation": "Newport News, VA",
    "city": "Newport News",
    "state": "VA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Newport%20News%2C%20VA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8246",
    "displayLocation": "Stafford, TX",
    "city": "Stafford",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Stafford%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6181",
    "displayLocation": "Papillion, NE",
    "city": "Papillion",
    "state": "NE",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Papillion%2C%20NE"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6335",
    "displayLocation": "Ocala, FL",
    "city": "Ocala",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Ocala%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6433",
    "displayLocation": "Vacaville, CA",
    "city": "Vacaville",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Vacaville%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6520",
    "displayLocation": "Vero Beach, FL",
    "city": "Vero Beach",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Vero%20Beach%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6779",
    "displayLocation": "Moore, OK",
    "city": "Moore",
    "state": "OK",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Moore%2C%20OK"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8158",
    "displayLocation": "Woodstock, GA",
    "city": "Woodstock",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Woodstock%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4780",
    "displayLocation": "Buford, GA",
    "city": "Buford",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Buford%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6189",
    "displayLocation": "Apopka, FL",
    "city": "Apopka",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Apopka%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6382",
    "displayLocation": "Las Vegaswest, NV",
    "city": "Las Vegaswest",
    "state": "NV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Las%20Vegaswest%2C%20NV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6401",
    "displayLocation": "Tampa, FL",
    "city": "Tampa",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Tampa%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6420",
    "displayLocation": "Clearwater, FL",
    "city": "Clearwater",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Clearwater%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6621",
    "displayLocation": "Roseville, CA",
    "city": "Roseville",
    "state": "CA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Roseville%2C%20CA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8167",
    "displayLocation": "Franklin, WI",
    "city": "Franklin",
    "state": "WI",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Franklin%2C%20WI"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4721",
    "displayLocation": "Houston (W'Brook), TX",
    "city": "Houston (W'Brook)",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Houston%20%28W%27Brook%29%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8221",
    "displayLocation": "Harvey, LA",
    "city": "Harvey",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Harvey%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4109",
    "displayLocation": "Bossier City, LA",
    "city": "Bossier City",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Bossier%20City%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6661",
    "displayLocation": "Portage, MI",
    "city": "Portage",
    "state": "MI",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Portage%2C%20MI"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6428",
    "displayLocation": "Medford, NY",
    "city": "Medford",
    "state": "NY",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Medford%2C%20NY"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6683",
    "displayLocation": "Murray, UT",
    "city": "Murray",
    "state": "UT",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Murray%2C%20UT"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8202",
    "displayLocation": "Savannah, GA",
    "city": "Savannah",
    "state": "GA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Savannah%2C%20GA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4917",
    "displayLocation": "Mooresville, NC",
    "city": "Mooresville",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Mooresville%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4956",
    "displayLocation": "Tempe, AZ",
    "city": "Tempe",
    "state": "AZ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Tempe%2C%20AZ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4987",
    "displayLocation": "Longmont Alt, CO",
    "city": "Longmont Alt",
    "state": "CO",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Longmont%20Alt%2C%20CO"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4729",
    "displayLocation": "Sterling, VA",
    "city": "Sterling",
    "state": "VA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Sterling%2C%20VA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4831",
    "displayLocation": "Durham South, NC",
    "city": "Durham South",
    "state": "NC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Durham%20South%2C%20NC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6505",
    "displayLocation": "Jefferson City, MO",
    "city": "Jefferson City",
    "state": "MO",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Jefferson%20City%2C%20MO"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6556",
    "displayLocation": "St Clairsville, OH",
    "city": "St Clairsville",
    "state": "OH",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20St%20Clairsville%2C%20OH"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8237",
    "displayLocation": "Monroe, LA",
    "city": "Monroe",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Monroe%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4974",
    "displayLocation": "North Las Vegas (Ne), NV",
    "city": "North Las Vegas (Ne)",
    "state": "NV",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20North%20Las%20Vegas%20%28Ne%29%2C%20NV"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6336",
    "displayLocation": "Temple, TX",
    "city": "Temple",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Temple%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6571",
    "displayLocation": "FLorence, SC",
    "city": "FLorence",
    "state": "SC",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20FLorence%2C%20SC"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6220",
    "displayLocation": "Slidell, LA",
    "city": "Slidell",
    "state": "LA",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Slidell%2C%20LA"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6252",
    "displayLocation": "Chesterfield, MO",
    "city": "Chesterfield",
    "state": "MO",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Chesterfield%2C%20MO"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8289",
    "displayLocation": "Oklahoma City West, OK",
    "city": "Oklahoma City West",
    "state": "OK",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Oklahoma%20City%20West%2C%20OK"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6424",
    "displayLocation": "Kokomo, IN",
    "city": "Kokomo",
    "state": "IN",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Kokomo%2C%20IN"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6867",
    "displayLocation": "Houston Cinco, TX",
    "city": "Houston Cinco",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Houston%20Cinco%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "4999",
    "displayLocation": "Quincy, IL",
    "city": "Quincy",
    "state": "IL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Quincy%2C%20IL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6434",
    "displayLocation": "Laurel, MD",
    "city": "Laurel",
    "state": "MD",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Laurel%2C%20MD"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6482",
    "displayLocation": "Dallas East, TX",
    "city": "Dallas East",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Dallas%20East%2C%20TX"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8150",
    "displayLocation": "Port St. Lucie, FL",
    "city": "Port St. Lucie",
    "state": "FL",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Port%20St.%20Lucie%2C%20FL"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6606",
    "displayLocation": "Phoenix, AZ",
    "city": "Phoenix",
    "state": "AZ",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Phoenix%2C%20AZ"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "6635",
    "displayLocation": "Littleton, CO",
    "city": "Littleton",
    "state": "CO",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20Littleton%2C%20CO"
  },
  {
    "retailer": "Sam's Club",
    "retailer_key": "sam",
    "clubNumber": "8190",
    "displayLocation": "La Marque, TX",
    "city": "La Marque",
    "state": "TX",
    "status": "Recently available",
    "product": "Veggie Crisps",
    "sku": "DJA7017-416US",
    "samsItemNumber": "980334704",
    "updated": "13/07/2026",
    "maps": "https://www.google.com/maps/search/?api=1&query=Sam%27s%20Club%20La%20Marque%2C%20TX"
  }
];
